import type { AppDispatch } from '@/app/store/store';
import { FiltersAdapter } from '../infra/adapters/filters.adapter';
import { createFiltersService } from '../application/services/FiltersService';

export function filtersBuild(dispatch: AppDispatch) {
  return {
    filtersService: createFiltersService(new FiltersAdapter(dispatch)),
  };
}
